module.exports = __webpack_public_path__ + "img/cloud-upload.b045a44d.svg";